import { CustomerCommercialCriteriaListResponseV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers/customerCommercialCriteriaListResponseV1";
import environment from "environment";
import { BaseService } from "@services/BaseService";
import { CommercialCriteria } from "@components/customer/CommercialCriteria.types";
import { useState } from "react";
import { t } from "i18next";

const useCommercialCriteria = () => {
  const [commercialCriteriaList, setCommercialCriteriaList] = useState<
    CommercialCriteria[]
  >([]);
  const [error, setError] = useState<string>();
  const [isCommercialCriteriaListLoading, setIsCommercialCriteriaLoading] =
    useState(false);

  const fetchCommercialCriteriaList = (orgId: string) => {
    setIsCommercialCriteriaLoading(true);
    setError("");
    const apiUrl =
      environment.api.organisationInfo + `/${orgId}` + "/commercialcriterias";
    BaseService.get<CustomerCommercialCriteriaListResponseV1[]>(apiUrl)
      .then(({ data }) => {
        setCommercialCriteriaList(data);
      })
      .catch(() => {
        setError(
          t("core:customers:fetch_failure_commercial_criteria") ||
            "Commercial criteria fetch Faliure..."
        );
      })
      .finally(() => {
        setIsCommercialCriteriaLoading(false);
      });
  };

  return {
    commercialCriteriaList,
    error,
    isCommercialCriteriaListLoading,
    fetchCommercialCriteriaList,
  };
};

export default useCommercialCriteria;
